import React, { useState } from 'react';
import './Contact.css';
// import PageBanner from '../components/PageBanner/PageBanner';
import contactBanner from '../assets/images/booking_banner.png';
import { toast } from 'react-toastify';
import { apiCall } from '../utils/api';

import { useLanguage } from '../contexts/LanguageContext';

function Contact() {
    const { t } = useLanguage();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePhone = (phone) => {
        const phoneRegex = /^[0-9]{10}$/;
        return phoneRegex.test(phone.replace(/\D/g, ''));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = 'contact.form.errors.name_required';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'contact.form.errors.email_required';
        } else if (!validateEmail(formData.email)) {
            newErrors.email = 'contact.form.errors.email_invalid';
        }

        if (!formData.phone.trim()) {
            newErrors.phone = 'contact.form.errors.phone_required';
        } else if (!validatePhone(formData.phone)) {
            newErrors.phone = 'contact.form.errors.phone_invalid';
        }

        if (!formData.subject.trim()) {
            newErrors.subject = 'contact.form.errors.subject_required';
        }

        if (!formData.message.trim()) {
            newErrors.message = 'contact.form.errors.message_required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            try {
                await apiCall('/contact', 'POST', formData);
                toast.success('Your message has been sent successfully!');

                setSubmitted(true);
                setTimeout(() => {
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        subject: '',
                        message: ''
                    });
                    setSubmitted(false);
                }, 3000);
            } catch (error) {
                toast.error('Failed to submit contact form: ' + error.message);
            }
        }
    };

    const handleWhatsApp = () => {
        const phoneNumber = '919370832534';
        const message = `Hello! I would like to get in touch.`;
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="contact-page">
            {/* Banner */}
            <div className="contact-banner-wrapper">
                <img
                    src={contactBanner}
                    alt="Contact Us"
                    className="contact-banner-image"
                />
                <div className="contact-banner-overlay">
                    <h1>{t('contact.banner.title')}</h1>
                    <p>{t('contact.banner.subtitle')}</p>
                </div>
            </div>

            {/* Contact Section */}
            <section className="contact-section">
                <div className="container">
                    <div className="contact-wrapper">
                        {/* Contact Form */}
                        <div className="contact-form-container">
                            <h2>{t('contact.form.title')}</h2>

                            {submitted ? (
                                <div className="success-message">
                                    <div className="success-icon">✓</div>
                                    <h3>{t('contact.form.success.title')}</h3>
                                    <p>{t('contact.form.success.desc')}</p>
                                    <p className="success-details">
                                        {t('contact.form.success.follow_up')} {formData.email}
                                    </p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="contact-form">
                                    {/* Name */}
                                    <div className="form-group">
                                        <label htmlFor="name">{t('contact.form.name')}</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder={t('contact.form.name_placeholder')}
                                            className={errors.name ? 'input-error' : ''}
                                        />
                                        {errors.name && <span className="error-message">{t(errors.name)}</span>}
                                    </div>

                                    {/* Email */}
                                    <div className="form-group">
                                        <label htmlFor="email">{t('contact.form.email')}</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder={t('contact.form.email_placeholder')}
                                            className={errors.email ? 'input-error' : ''}
                                        />
                                        {errors.email && <span className="error-message">{t(errors.email)}</span>}
                                    </div>

                                    {/* Phone */}
                                    <div className="form-group">
                                        <label htmlFor="phone">{t('contact.form.phone')}</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder={t('contact.form.phone_placeholder')}
                                            className={errors.phone ? 'input-error' : ''}
                                        />
                                        {errors.phone && <span className="error-message">{t(errors.phone)}</span>}
                                    </div>

                                    {/* Subject */}
                                    <div className="form-group">
                                        <label htmlFor="subject">{t('contact.form.subject')}</label>
                                        <input
                                            type="text"
                                            id="subject"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            placeholder={t('contact.form.subject_placeholder')}
                                            className={errors.subject ? 'input-error' : ''}
                                        />
                                        {errors.subject && <span className="error-message">{t(errors.subject)}</span>}
                                    </div>

                                    {/* Message */}
                                    <div className="form-group">
                                        <label htmlFor="message">{t('contact.form.message')}</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            placeholder={t('contact.form.message_placeholder')}
                                            rows="6"
                                            className={errors.message ? 'input-error' : ''}
                                        />
                                        {errors.message && <span className="error-message">{t(errors.message)}</span>}
                                    </div>

                                    {/* Submit Button */}
                                    <button type="submit" className="submit-btn">
                                        {t('contact.form.submit')}
                                    </button>
                                </form>
                            )}
                        </div>

                        {/* Contact Info */}
                        <div className="contact-info-container">
                            <h3>{t('contact.info.title')}</h3>



                            <div className="contact-info-card">
                                <div className="info-icon">📞</div>
                                <div className="info-content">
                                    <h4>{t('contact.info.phone_title')}</h4>
                                    <p>+91 9370832534</p>
                                </div>
                            </div>

                            <div className="contact-info-card">
                                <div className="info-icon">📧</div>
                                <div className="info-content">
                                    <h4>{t('contact.info.email_title')}</h4>
                                    <p>yogakaregaindia@gmail.com</p>
                                </div>
                            </div>

                            <div className="contact-info-card">
                                <div className="info-icon">🕒</div>
                                <div className="info-content">
                                    <h4>{t('contact.info.hours_title')}</h4>
                                    <p>{t('contact.info.hours_days')}<br />{t('contact.info.hours_time')}</p>
                                </div>
                            </div>

                            <button className="whatsapp-btn" onClick={handleWhatsApp}>
                                💬 {t('contact.info.whatsapp')}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Map Section */}
            {/* <section className="map-section">
                <div className="container">
                    <h2>Find Us Here</h2>
                    <div className="map-container">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3548.2!2d77.9!3d27.2!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjfCsDEyJzAwLjAiTiA3N8KwNTQnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
                            width="100%"
                            height="400"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Yoga Karega India Location"
                        ></iframe>
                    </div>
                </div>
            </section> */}
        </div>
    );
}

export default Contact;
